import { memo } from 'react';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { normalizeValue } from '../utils/normalizeValue';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import TextInputAdapter from '../adapters/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputEmailV2 = props => {
  const {
    autoFocus,
    disabled,
    inputRef,
    onChange,
    readOnly,
    shouldOverrideValue,
    overrideValue
  } = props;
  let value = usePropertyValue();
  if (shouldOverrideValue) {
    value = overrideValue;
  }
  useComponentMountMetric('PropertyInputEmailV2');
  return /*#__PURE__*/_jsx(TextInputAdapter, Object.assign({}, getTransferrableProps(props), {
    autoFocus: autoFocus,
    disabled: disabled,
    value: normalizeValue(value),
    onChange: onChange,
    readOnly: readOnly,
    inputRef: inputRef,
    type: "email"
  }));
};
export default /*#__PURE__*/memo(PropertyInputEmailV2);